export function HolocronPageBackdrop() {
  return (
    <div className="page-holocron-backdrop" aria-hidden="true">
      <div className="page-holocron-grid" />
      <div className="page-holocron-beam page-holocron-beam--one" />
      <div className="page-holocron-beam page-holocron-beam--two" />
      <div className="page-holocron-orbit page-holocron-orbit--outer" />
      <div className="page-holocron-orbit page-holocron-orbit--inner" />
      <div className="page-holocron-artifact">
        <span className="page-holocron-core" />
        <span className="page-holocron-face page-holocron-face--front" />
        <span className="page-holocron-face page-holocron-face--left" />
        <span className="page-holocron-face page-holocron-face--right" />
        <span className="page-holocron-rune page-holocron-rune--one" />
        <span className="page-holocron-rune page-holocron-rune--two" />
        <span className="page-holocron-rune page-holocron-rune--three" />
      </div>
    </div>
  );
}
